import { render, staticRenderFns } from "./supplierOrdersLogModal.vue?vue&type=template&id=53a6dac0&scoped=true"
import script from "./supplierOrdersLogModal.vue?vue&type=script&lang=js"
export * from "./supplierOrdersLogModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a6dac0",
  null
  
)

export default component.exports